import { useEffect, useState } from "react";

/** Single 1s clock for all KDS ticket timers (avoids N intervals). */
export function useKdsClock() {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  return now;
}
